/*
* 响应拦截器，用于记录响应日志。
* */
import {comTag, ResDataInterceptor} from '@/Fwk/Http/comRequest';
import Util from "@/Master/Util";
import {HttpConfig} from "@/Fwk/Http/HttpConfig";
import AESHelper from "@/Fwk/Encrypt/AESHelper";
import {WebCode} from "@/app/types/WebCode";
import RouterMgr from "@/Core/RouterMgr";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import {LoginUserType} from "@/Core/Login/types/user";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {StartManager} from "@/Core/StartManager";
import {LoginFailedDialogFC} from "@/app/_dialogs/LoginFailedDialog/LoginFailedDialog";
import LoginNetManager from "@/Core/Login/LoginNetManager";
import {ErrDialogFC, showErrDialog} from "@/app/_dialogs/ErrDialog/ErrDialog";
import {Toast} from "@/app/_components";
import {getLoginType} from "@/app/utils/auth";
import {LoginType} from "@/app/userSlice";
import AuthTrack, {LoginScene} from "@/Core/AuthTrack";

export const LogResDataInterceptor: ResDataInterceptor = async (finalData: any,config:HttpConfig) => {
    if (Util.isLog) {
        console.log(comTag,'响应拦截器-日志-finalData:', config.url,finalData);
        // console.log(comTag,'响应拦截器-日志-config:',config.url, config);
    }

    if (finalData.code == 200 ) {
        if (config.encryptionType == 'RSA') {
            try {
                if (finalData.data) {
                    const dataStr = AESHelper.DecryptWeb(finalData.data);
                    finalData.data = JSON.parse(dataStr);
                } else {
                    finalData.data = {};
                }
            } catch (error) {
                if (Util.isLog) {
                    console.error(comTag,'响应拦截器-解密错误:',config.url, finalData);
                }
            }
        }
    } else {
        // todo 暂时在这里增加服务端错误提示
        if (finalData.code === WebCode.ServerError) {
            Toast.show("Service error")
        }

        // todo 暂时在这里增加登陆账号密码错误提示
        if (finalData.code === WebCode.AccountPwdError) {
            Toast.show("Incorrect passwords or phone number")
        }

        // todo 暂时在这里增加注册账号已存在提示
        if (finalData.code === WebCode.AccountExist) {
            Toast.show("Account already exists")
        }

        // todo 暂时在这里增加验证码校验错误提示
        if (finalData.code === WebCode.VerifyCodeError) {
            Toast.show("Incorrect verification code")
        }

        // todo 暂时在这里增加验证码过期错误提示
        if (finalData.code === WebCode.VerifyCodeExpired) {
            Toast.show("Verification code expired")
        }

        // todo 暂时在这里增加token过期错误提示
        if (finalData.code === WebCode.LostToken) {
            Toast.show("Token expired")
            if (getLoginType() === LoginType.visitor) {

            } else {
                AuthTrack.showLogin(LoginScene.TokenExpired)
                RouterMgr.login();
                return finalData;
            }
        }

        if (config.isSerErrTips){
            // 1001401  token过期
            // 1001500  服务异常
            // 1001501  参数为空
            // 1001502  参数异常
            // 1001504  请求数据错误
            // 1022101  token数据不存在
            // 1022103  token不一致
            // 1022104  产品错误
            // 1022105  基础信息缺失
            // 1022202  账户密码错误
            // 1022203  其他设备在线
            // 1022204  用户ID不存在
            // 1022205  用户ID已注册
            // 1022206  手机号未注册
            // 1022207  手机号已注册
            // 1022920  奖励重复领取

            const {code, data, message, timestamp, description, etag} = finalData;
            switch (finalData.code) {
                case WebCode.LostToken:
                    const loginType = LoginUIManager.getLastUserLoginType;
                    if (loginType == LoginUserType.normal){
                        RouterMgr.login();
                    }else{
                        RouterMgr.home();
                        RouterMgr.refresh();
                        SDialogManagerFC.openDialog(LoginFailedDialogFC,{
                            fcKey:SDialogManagerFC.getFCKey(LoginFailedDialogFC),
                            onRefresh:()=>{
                                StartManager.checkLogin();
                            },
                            onClose:(isOk:boolean)=>{
                                StartManager.checkLogin();
                            }
                        })
                    }
                    break;
                case WebCode.ForceLogOut://强制登出
                    LoginNetManager.Instance.SendLogout((isOk:boolean)=>{
                        if (isOk) {
                            RouterMgr.login();
                        }
                    });
                    break;
                default:
                    const {isRefresh} = await showErrDialog(code, message || description);
                    if (isRefresh){
                        config.retry!+=1;
                    }
                    break;
            }
        }


        if (Util.isLog) {
            console.warn(comTag, `响应拦截器-错误返回代码:{${Util.getEnumName(WebCode, finalData.code)}}`, config.url, finalData);
        }

    }

    return {finalData,config};
};